import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noResultsPageTitle: { id: 'modules-expertDirectory-noResultsPageTitle' },
  noResultsPageDescription: { id: 'modules-expertDirectory-noResultsPageDescription' },
  backToPreviousPage: { id: 'modules-expertDirectory-backToPreviousPage' },
  noResultToast: { id: 'modules-expertDirectory-noResultToast' },
});

export default messages;
